// extracted by mini-css-extract-plugin
export default {"title-section":"Rkcmm+I+Nf","titleSection":"Rkcmm+I+Nf"};